import type { Notification } from '~/dashboard/context';

export const filterNotifications = (notifications: Notification[] = []) => (
  notifications?.filter(({ viewed }) => !viewed)
);
